import { installDevEditingPauseHooks } from "@/lib/dev-editing-pause";

installDevEditingPauseHooks();
